import script from "./KnowledgeBaseManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBaseManagement.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBaseManagement.vue?vue&type=style&index=0&id=10f20fb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f20fb7"]])

export default __exports__